


















































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Lazy } from '../../../core/utils';
import StepperHeaders from './StepperHeaders.vue';
import ConditionStepper from './ConditionStepper.vue';
import VisualizationStepper from './VisualizationStepper.vue';
import DescriptionStepper from './DescriptionStepper.vue';
import { AddFilterStore } from './state';
import { Filter, FilterConditions, Visualization } from '../../../core/models';
import { pluckAndStartWatch } from '../../../core/operators';
import { map, startWith, tap } from 'rxjs/operators';
import { TrackingService } from '../../../core/api';
import { NotificationStoreHelper, RootStoreHelper } from '../../../core/mixins';
import { cssNormal, cssWarning } from '../../utils';
import { fromFilterToSaveFilter } from '../index';

@Component<AddFilter>({
    components: { DescriptionStepper, VisualizationStepper, ConditionStepper, StepperHeaders },
    subscriptions() {
        const headClass$ = this.store.headClass$;
        return {
            open$: this.$watchAsObservable('openAddFilterDialog').pipe(
                pluckAndStartWatch(false),
                tap((open: boolean) => {
                    if (open) {
                        this.store.reset();
                        if (this.currentFilter) {
                            this.store.updateFilter(this.currentFilter);
                        }
                        this.resetHeaderErrors();
                        this.$nextTick(this.resetForms);
                    }
                })
            ),
            title$: this.store.title$,
            step$: this.store.step$.pipe(
                tap((step: number) => {
                    this.resetHeaderErrors();
                })
            ),
            headClass$: this.store.headClass$,
            conditions$: this.store.conditions$,
            visualizations$: this.store.visualizations$,
            name$: this.store.name$,
            loading$: this.store.selectLoading(),
            normal$: headClass$.pipe(
                map<string, boolean>(headClass => headClass === cssNormal),
                startWith(true)
            ),
            warning$: headClass$.pipe(
                map<string, boolean>(headClass => headClass === cssWarning),
                startWith(false)
            )
        };
    }
})
export default class AddFilter extends Mixins(NotificationStoreHelper, RootStoreHelper) {
    @Prop({ default: false }) openAddFilterDialog: boolean;
    @Prop() closeAddFilterDialog: Lazy<void>;
    @Prop() showManagerFilterDialog: Lazy<void>;
    @Prop() company: string;
    @Prop() currentFilter: Filter;
    store: AddFilterStore = new AddFilterStore();
    title$: string;
    open$: boolean;
    step$: number;
    headClass$: string;
    name$: string;
    conditions$: FilterConditions[];
    visualizations$: Visualization[];
    validateStepOne: boolean = true;
    validateStepTwo: boolean = true;
    loading$: boolean;
    normal$: boolean;
    warning$: boolean;
    messageWarning = '¿Esta seguro de cancelar?';

    get shouldStepEditable(): boolean {
        return this.currentFilter !== null;
    }

    addCondition(condition: FilterConditions): void {
        this.store.addCondition(condition);
    }

    addVisualization(visualization: Visualization): void {
        this.store.addVisualization(visualization);
    }

    removeCondition(condition: FilterConditions): void {
        this.store.removeCondition(condition);
    }

    removeVisualization(visualization: Visualization): void {
        this.store.removeVisualization(visualization);
    }

    existConditions(): boolean {
        return this.conditions$.length > 0;
    }

    existValidations(): boolean {
        return this.visualizations$.length > 0;
    }

    validateConditions(): void {
        this.validateStepOne = this.existConditions();
    }

    validateVisualization(): void {
        this.validateStepTwo = this.existValidations();
    }

    removeConditionAndCheckState(condition: FilterConditions): void {
        this.removeCondition(condition);
        this.validateConditions();
    }

    removeVisualizationAndCheckState(visualization: Visualization): void {
        this.removeVisualization(visualization);
        this.validateVisualization();
    }

    addConditionAndCheckState(condition: FilterConditions): void {
        this.addCondition(condition);
        this.validateConditions();
    }

    addVisualizationAndCheckState(visualization: Visualization): void {
        this.addVisualization(visualization);
        this.validateVisualization();
    }

    updateName(name: string): void {
        this.store.updateName(name);
    }

    resetHeaderErrors(): void {
        this.validateStepOne = true;
        this.validateStepTwo = true;
    }

    get conditionStepper(): any {
        return this.$refs.conditionStepper as any;
    }

    get visualizationStepper(): any {
        return this.$refs.visualizationStepper as any;
    }

    get descriptionStepper(): any {
        return this.$refs.descriptionStepper as any;
    }

    resetForms(): void {
        this.conditionStepper.resetForm();
        this.visualizationStepper.resetForm();
        this.descriptionStepper.resetForm();
    }

    handleFinish(): void {
        this.store.updateLoading(true);
        const filter = this.store.getFilter();
        const filterToSave = fromFilterToSaveFilter(filter, this.$_getVariables);
        if (filter.id) {
            TrackingService.patchFilters(filterToSave, filter.id)
                .then(response => {
                    if (response['status'] === 200 || response['status'] === 204) {
                        this.$_successAddFilter('Filtro actualizado correctamente');
                        this.store.updateLoading(false);
                        this.store.reset();
                        this.resetHeaderErrors();
                        this.closeAddFilterDialog();
                        this.showManagerFilterDialog();
                        this.$nextTick(this.resetForms);
                    }
                })
                .catch(error => {
                    if (error && error.response && error.response.data && error.response.data.message) {
                        this.$_errorAddFilter(error.response.data.message);
                    } else {
                        this.$_errorAddFilter('Problema editando filtro');
                    }
                    this.store.updateLoading(false);
                });
        } else {
            TrackingService.postFilters(filterToSave, this.company)
                .then(response => {
                    if (response['status'] === 200 || response['status'] === 204) {
                        this.$_successAddFilter('Filtro añadido correctamente');
                        this.store.updateLoading(false);
                        this.store.reset();
                        this.resetHeaderErrors();
                        this.closeAddFilterDialog();
                        this.showManagerFilterDialog();
                        this.$nextTick(this.resetForms);
                    } else {
                        this.$_errorAddFilter('Error añadiendo filtro. Consulte a su administrador');
                    }
                })
                .catch(error => {
                    if (error && error.response && error.response.data && error.response.data.message) {
                        this.$_errorAddFilter(error.response.data.message);
                    } else {
                        this.$_errorAddFilter('Ocurrió un error al crear el filtro');
                    }
                    this.store.updateLoading(false);
                });
        }
    }

    handleCancelAdd(): void {
        this.store.updateHeadClass(cssWarning);
    }

    handleEnter(): void {
        switch (this.step$) {
            case 1:
                this.conditionStepper.handleNext();
                break;
            case 2:
                this.visualizationStepper.handleNext();
                break;
        }
    }

    cancelConfirm(): void {
        this.store.updateHeadClass(cssNormal);
    }

    handleHeadersUpdateStep(step: number): void {
        this.store.updateStep(step);
    }
}
